import React from 'react'

export default (props) => <div
  style={{
    background: '#fff',
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 100,
    flexDirection: 'column',
  }}
>
  <div
    style={{
      width: '100%',
      height: 80,
      background: '#eee',
      position: 'absolute',
      top: 0,
      left: 0,
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center'
    }}
  >
    <button
      className="uk-button uk-button-secondary uk-button-small"
      data-test-id="reset-sandbox-btn"
      disabled={props.resetDisabled}
      id="proxy-reset-loader"
      onClick={props.handleReset}
      style={{
        textTransform: 'none',
        fontSize: 13,
        marginRight: 100
      }}
      type="button"
    >
      <span className="uk-margin-small-right" data-uk-icon="icon: refresh; ratio: 0.7" />
      Reset Sandbox
</button>
  </div>
  <div data-uk-spinner="" />
  <p data-test-id="loading-sandbox-msg">Loading Question...</p>
  <div
    style={{
      width: 80,
      float: 'right',
      height: '100%',
      background: '#222',
      position: 'absolute',
      top: 0,
      right: 0,
    }}
  >

    <div className="uk-text-center uk-margin-top" id="proxy-request-button">
      <button
        className="uk-icon-button uk-background-secondary uk-light"
        type="button"
        data-test-id="proxy-sidebar-btn"
        data-uk-icon="icon: bolt"
      />
      <br />
      <button
        className="uk-button uk-button-text uk-light"
        style={{ fontSize: 12 }}
        type="button"
      >
        PROXY
  </button>
    </div>
    <div className="uk-text-center uk-margin-top" id="proxy-history-button">
      <button
        data-test-id="sidebar-proxy-history-btn"
        className="uk-icon-button uk-background-secondary uk-light"
        type="button"
        data-uk-icon="icon: world"
      />
      <br />
      <button
        className="uk-button uk-button-text uk-light"
        style={{ fontSize: 12 }}
        type="button"
      >
        HISTORY
  </button>
    </div>
  </div>
</div>